import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import Component from '../components/signup.step'
import {FacebookLogin, Signup as SignUpHandler} from '../../../state/login/actions'
import {push} from 'react-router-redux'

class Container extends React.Component {

  continueFacebook = (response) => {
    this.props.handleFacebookSignIn(response)
      .then(success => {
        if (success) this.props.requestNextStep()
      })
  }

  continueEmail = () => {
    this.props.handleSignUpClick()
      .then(success => {
        if (success) this.props.requestNextStep()
      })
  }

  close = () => {
    this.props.requestExit()
  }

  goToLogin = () => {
    this.props.requestSpecificStep('login')
  }

  render() {
    return (
      <Component
        {...this.props}
        continueFacebook={this.continueFacebook}
        continueEmail={this.continueEmail}
        goToLogin={this.goToLogin}
        close={this.close}
      />
    )
  }

  static propTypes = {
    requestNextStep: PropTypes.func.isRequired,
    requestExit: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  const login = state.ui.login
  return {
    email: login.signup.email,
    emailError: login.signup.emailError,
    name: login.signup.name,
    nameError: login.signup.nameError,
    lastName: login.signup.lastName,
    lastNameError: login.signup.lastNameError,
    password: login.signup.password,
    passwordError: login.signup.passwordError,
    isFetching: login.signup.isFetching,
    error: login.signup.error,
    facebookIsFetching: login.facebookLogin.isFetching,
    facebookError: login.facebookLogin.error,
    isFormLoading: state.ui.depositV2.deposit.get('flowLoading'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setEmail: email => dispatch(SignUpHandler.setEmail(email)),
    setName: name => dispatch(SignUpHandler.setName(name)),
    setLastName: lastName => dispatch(SignUpHandler.setLastName(lastName)),
    setPassword: password => dispatch(SignUpHandler.setPassword(password)),
    handleSignUpClick: () => dispatch(SignUpHandler.signup()),
    handleFacebookSignIn: response => dispatch(FacebookLogin.login(response)),
    removeURL: () => dispatch(push('/micatalogo')),
    updateUrl: () => dispatch(push({search: '?s=registro'})),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/depositV2/containers/signup.js